module.exports = __webpack_public_path__ + "static/split-bills-9296a552b760f6d9d6a8dcf55d0f6ec5.png";